import { render, staticRenderFns } from "./customerRoomDetail.vue?vue&type=template&id=c7500da4&scoped=true&"
import script from "./customerRoomDetail.vue?vue&type=script&lang=js&"
export * from "./customerRoomDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerRoomDetail.vue?vue&type=style&index=0&id=c7500da4&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7500da4",
  null
  
)

export default component.exports